export const animateStat = (stat) => {
    const $ = jQuery;

    let number = $(stat).find('.animate').data('stat') + '';
    
    number = number.split(',').join('');

    $(stat).find('.animate').prop('Counter', 0).animate({
        Counter: number
    },
    {
        duration: 3000,
        easing: 'swing',
        step: (now) => {
            let number = Math.ceil(now).toLocaleString('en');
            
            number = number.replace('.00', '');
            
            $(stat).find('.animate').text(number);
        }
    });
}